export const GET_GENERATING_UNIT_FEATURES = "GET_GENERATING_UNIT_FEATURES";
export const SET_GENERATING_UNIT_FEATURES_RESULT = "SET_GENERATING_UNIT_FEATURES_RESULT";
export const RESET_GENERATING_UNIT_FEATURES = "RESET_GENERATING_UNIT_FEATURES";
export const SET_FEATURES_ERROR = "SET_FEATURES_ERROR";